import React from 'react';
import { Typography, Box } from '@mui/material';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';

import { Card } from 'Components/Card';

const ChartLine = ({ title, data, tooltipLabel, color = '#8A2BE2', height = 210 }) => {
  const gradientId = 'gradientFill';

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Card>
      <Typography variant="subtitle1" fontWeight="bold" className="mb-4">
        {title}
      </Typography>

      <Box display="flex" alignItems="center" justifyContent="center">
        <ResponsiveContainer width="100%" height={height}>
          <AreaChart  data={data}>
            {/* Gradiente */}
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.4} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>

            {/* Grid suave apenas horizontal */}
            <CartesianGrid strokeDasharray="3 3" vertical={false} />

            <XAxis
              dataKey="date"
              tickFormatter={formatDate}
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              domain={[0, 100]}
              tickFormatter={(v) => `${v}%`}
              tick={{ fontSize: 12 }}
              tickLine={false}
              axisLine={false}
            />

            <Tooltip
              formatter={(value) => [`${value.toFixed(2)}%`, tooltipLabel]}
              labelFormatter={formatDate}
            />

            {/* Linha + sombra */}
            <Area
              type="monotone"
              dataKey="value"
              stroke={color}
              fill={`url(#${gradientId})`}
              strokeWidth={2}
              dot={false}
            />
          </AreaChart >
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default ChartLine;
